import { gql, useMutation } from '@apollo/client';
import { UserAuthContext } from 'contexts/UserAuthContext';
import { ERROR_TYPE, TTError, handleException } from 'models/ErrorHandling';
import { enqueueSnackbar } from 'notistack';
import { useContext } from 'react';
import { ClassModel } from './ClassModel';

const SAVE_GQL = gql`
    mutation save($className: String!, $id: ID!) {
        updateClass(data: { className: $className }, where: { id: $id }) {
            id
            className
        }
    }
`;

type MutationVariableType = {
    id: string;
    className: string;
};

type MutationType = {
    updateClass: ClassModel;
};

export const useClassModelUpdateMutation = () => {
    const { accessDenied } = useContext(UserAuthContext);
    const [saveForm] = useMutation<MutationType>(SAVE_GQL);

    const update = async (variables: MutationVariableType) => {
        try {
            const result = await saveForm({
                variables,
            });

            if (!result || !result.data?.updateClass) {
                throw new TTError(ERROR_TYPE.UPDATE_FAILED);
            }
        } catch (err) {
            const errMessage = handleException(err);
            if (errMessage === ERROR_TYPE.KS_ACCESS_DENIED) {
                accessDenied(errMessage);
            } else {
                enqueueSnackbar(errMessage, {
                    variant: 'error',
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                });
            }
            throw new TTError();
        }
    };

    return { update };
};
